import { createContext, useContext, useEffect, useState } from "react";
import { STR } from "./dict";
import { MR, GU } from "./dict2";

const ALL = { ...STR, mr: MR, gu: GU };

const LanguageContext = createContext();

export const LANGUAGES = [
  { code: "en", native: "English" },
  { code: "hi", native: "हिन्दी" },
  { code: "mr", native: "मराठी" },
  { code: "gu", native: "ગુજરાતી" },
];

export const LanguageProvider = ({ children }) => {
  const [lang, setLangState] = useState(() => localStorage.getItem("site-lang") || "en");

  const setLang = (l) => {
    setLangState(l);
    localStorage.setItem("site-lang", l);
  };

  useEffect(() => {
    document.documentElement.lang = lang;
    document.documentElement.dataset.lang = lang;
  }, [lang]);

  const t = (key, vars) => {
    let s = ALL[lang]?.[key] ?? ALL.en[key] ?? key;
    if (vars) {
      Object.entries(vars).forEach(([k, v]) => {
        s = s.replaceAll(`{${k}}`, v);
      });
    }
    return s;
  };

  return (
    <LanguageContext.Provider value={{ lang, setLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLang = () => useContext(LanguageContext);
